import { render, staticRenderFns } from "./BusinessMemberHistoryBaseEvent.vue?vue&type=template&id=83fb16cc"
import script from "./BusinessMemberHistoryBaseEvent.vue?vue&type=script&lang=js"
export * from "./BusinessMemberHistoryBaseEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports